import React, { Component } from "react";
import COLORS from "scss/colors.module.scss";

export default class TextColumnEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.getDefaultValue(props) + "",
      maxCharLimitReached: false,
    };
    this.arrowKeyNavigation = this.arrowKeyNavigation.bind(this);
  }

  getDefaultValue(props) {
    return props.charPress ? props.charPress : props.value ? props.value : "";
  }

  handleChange = (value = this.state.value) => {
    if (
      !this.props.columnOptions.max_length ||
      value.length <= this.props.columnOptions.max_length
    ) {
      if(this.props.colDef.store.isLazyLoadEnabled) {
        this.props.colDef.store.isCurrentRowSaving = true;
      }
      this.props.onChange(value);
      this.setState({ value: value, maxCharLimitReached: false });
    } else {
      this.props.onChange(value);
      this.setState({ value: value, maxCharLimitReached: true });
    }
  };

  componentDidMount() {
    this.refs.container.addEventListener("keydown", this.arrowKeyNavigation);
    this.focus();
  }

  componentWillUnmount() {
    this.refs.container.removeEventListener("keydown", this.arrowKeyNavigation);
  }

  focusNextCell = (rowIndex, colId, isArrowDown = false) => {
    this.props.api.clearRangeSelection();
    this.props.api.stopEditing();
    if (isArrowDown) {
      this.props.colDef.store.addRowOnGrid(
        rowIndex,
        this.props.node.id,
        this.props.context,
        colId
      );
    }
    this.props.api.setFocusedCell(rowIndex, colId);
  };

  arrowKeyNavigation = (event) => {
    if ([13].indexOf(event.keyCode) > -1) {
      this.handleChange();
      this.focusNextCell(this.props.rowIndex + 1, this.props.column.colId, true); 
    }
    if (event.key === "ArrowUp") {
      event.preventDefault();
      this.focusNextCell(
        this.props.rowIndex === 0 ? 0 : this.props.rowIndex - 1,
        this.props.column.colId
      );
    }
    if (event.key === "ArrowDown") {
      event.preventDefault();
      this.focusNextCell(this.props.rowIndex + 1, this.props.column.colId, true);
    }
  };

  getValue() {
    return this.state.value;
  }

  isPopup() {
    return false;
  }

  focus() {
    window.setTimeout(() => {
      if (this.refs.input) {
        this.refs.input.focus();
        this.refs.input.value = "";
        this.refs.input.value = this.state.value;
      }
    }, 10);
  }

  render() {
    return (
      <div
        ref="container"
        style={{
          width: Number(this.props.colDef.width) - 15,
        }}
        onClick={() => {
          this.refs.input.focus();
        }}
      >
        <input
          ref="input"
          style={{
            ...styles.input,
            width: Number(this.props.colDef.width) - 15,
            border: "none",
            outline: "none",
          }}
          onChange={(e) => this.handleChange(e.target.value)}
          value={this.state.value}
        />
        <div
          className="textCellWarning"
          style={{
            marginTop: this.props.node.rowHeight - 10,
            display: this.state.maxCharLimitReached ? "flex" : "none",
          }}
        >
          Reached the maximum character limit of{" "}
          {this.props.columnOptions.max_length} character(s).{" "}
          {this.props.context.props.store.listConfig?.listPermissions
            ?.is_admin === "1"
            ? "To make changes to this column, please select Edit Field from the header menu."
            : ""}
        </div>
      </div>
    );
  }
}

const styles = {
  input: {
    borderRadius: 5,
    backgroundColor: COLORS.PRIMARY_COLOR,
    position: "absolute",
    top: 5,
    left: 8,
    lineHeight: "2em",
  },
};
